import React from 'react';
import AutoCompleteInput from './';
import MembersApi from '../../../../services/portal-api/MembersApi';

export default class UserAutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uname: [],
        }

        MembersApi.fetchAllUsers((result) => {
            if (result.success) {
                let users = result.json.map((user, i) => ({
                    id: i,
                    key: user.username,
                    display: `${user.username.trim()} - Stores: ${user.allStores.trim()}`,
                    value: user.username.trim(),
                    ...user
                }));

                this.state["uname"] = users;
            }
        }, 'byAdmins');

        this.searchSuburbs = this.searchSuburbs.bind(this);
        this.onSuburbSelected = this.onSuburbSelected.bind(this);
    }

    // componentDidUpdate(prevProps) {
    //     console.log(this.props.value, prevProps.value);

    //     if (this.props.country == 'globals_au' || this.props.country == 'globals_nz') {
    //         MembersApi.fetchAllUsers((result) => {
    //             if (result.success) {
    //                 let users = result.json.map((user, i) => ({
    //                     id: i,
    //                     key: user.username,
    //                     display: `${user.username.trim()} - Stores: ${user.allStores.trim()}`,
    //                     value: user.username.trim(),
    //                     ...user
    //                 }));
    //                 this.state["uname"] = users;
    //             }
    //         }, 'byAdmins');
    //     }
    // }

    onChange = (event) => {
        this.props.onChange(event);
    };

    onSuburbSelected = (suburbId) => {
        let users = [];
        users = this.state.uname;
        if(!users) {
            return;
        }

        const user = users.find(user => user.id === suburbId);
        if (!user) {
            return;
        }

        this.props.onSuburbSelected({
            uname: user,
        });
    };

    searchSuburbs(_value) {
        const value = _value.toLowerCase().trim();
        let users = [];
        users = this.state["uname"];
        if(users) {
            const matches = users.filter(user => user.key.indexOf(value) === 0);
            const distanceMatches = matches.map(m => ({ ...m, dist: m.key.length - value.length }));
            distanceMatches.sort((a, b) => a.dist - b.dist);
            return distanceMatches;
        }
        return [];
    }

    render() {

        return (
            <AutoCompleteInput
                name={this.props.name}
                label={this.props.label}
                value={this.props.value}
                onChange={this.onChange}
                onSelected={this.onSuburbSelected}
                error={this.props.error}
                getSuggestions={this.searchSuburbs}
                autoComplete="off"
            />
        );
    }
}

